module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noInvitation":"No pending invitation","title":"@:labels.pendingInvitations"},"fr":{"noInvitation":"Pas d\u0027invitation en attente","title":"@:labels.pendingInvitations"}}')
  delete Component.options._Ctor
}
